import { RBAC } from '@/constants/rbacPermissions'
import { RBAC_PAGES, resolveRouteEntryPermission } from '@/constants/rbacPages'
import { REGISTRATION_NAV_PERMISSIONS } from '@/utils/rbac'

/**
 * 是否为 rbacPages.json 标记的超管专属路由（侧栏 superAdminOnly 对应页）
 * @param {import('vue-router').RouteLocationNormalized} to
 */
export function isSuperAdminOnlyRoute (to) {
  const path = String(to?.path || '')
  const name = String(to?.name || '')

  for (const page of RBAC_PAGES) {
    if (!page.superAdminOnly) continue
    if (page.routeNames?.includes(name)) return true
    for (const base of [page.routePath, page.routePathEdit]) {
      if (!base) continue
      const pattern = String(base).replace(/\{[^}]+\}/g, '[^/]+')
      const re = new RegExp(`^${pattern.replace(/\//g, '\\/')}(\\/|$)`)
      if (re.test(path)) return true
    }
  }
  return false
}

/**
 * 解析路由所需子权限：优先 meta.permission，否则 rbacPages 路由入口，再按 path/name 推断
 * @param {import('vue-router').RouteLocationNormalized} to
 * @returns {string|string[]|null}
 */
export function resolveRoutePermissionMeta (to) {
  if (to.meta?.permission) return to.meta.permission

  const path = to.path || ''
  const fromPage = resolveRouteEntryPermission(path)
  if (fromPage) return fromPage

  const name = String(to.name || '')

  if (name === 'Dashboard') return RBAC.ALBUM_LIST
  if (name === 'Accounts') return RBAC.ACCOUNT_LIST
  if (name === 'Permissions') return RBAC.PERMISSION_LIST
  if (name === 'Roles') return RBAC.PERMISSION_LIST
  if (name === 'CompanyManage') return RBAC.COMPANY_LIST
  if (name === 'ResourceGrantManage') return RBAC.RESOURCE_GRANT_LIST

  if (name === 'ConferenceEvents') return RBAC.ACTIVITY_LIST
  if (name === 'ConferenceRegistrations') return REGISTRATION_NAV_PERMISSIONS
  if (name === 'ConferenceHotels') return RBAC.HOTEL_LIST
  if (name === 'RegistrationFormEdit') {
    return [RBAC.REGISTRATION_EDIT, RBAC.PROXY_SUBMISSION_LIST, RBAC.SUBMISSION_LIST, RBAC.ORDER_LIST]
  }

  /** 会务 · 活动向导子页（须在通用 create/edit 之前匹配） */
  if (/\/schedule(\/|$)/.test(path)) return RBAC.ACTIVITY_SCHEDULE_LIST
  if (/\/seating\/editor(\/|$)/.test(path)) {
    return [RBAC.ACTIVITY_SEAT_QUERY_VIEW, RBAC.ACTIVITY_SEAT_LIST]
  }
  if (/\/seating(\/|$)/.test(path)) return RBAC.ACTIVITY_SEAT_LIST
  if (/\/microsite\/pages\/[^/]+\/edit/.test(path)) return RBAC.ACTIVITY_MICROSITE_PAGE_VIEW
  if (/\/microsite(\/|$)/.test(path)) return RBAC.ACTIVITY_MICROSITE_PAGES_LIST

  if (path.includes('/conference/events/create')) return RBAC.ACTIVITY_CREATE
  if (/\/conference\/events\/\d+\/edit/.test(path)) return RBAC.ACTIVITY_EDIT

  /** 相册 · 向导子页与图片管理 */
  if (/\/albums\/\d+\/photos/.test(path)) return RBAC.ALBUM_PHOTOS_LIST
  if (/\/albums\/\d+\/retouch/.test(path)) return RBAC.ALBUM_AI_RETOUCH
  if (/\/workbench\/auditor/.test(path)) return RBAC.ALBUM_AUDIT_PHOTO
  if (/\/workbench\//.test(path)) return RBAC.ALBUM_PHOTOS_UPLOAD
  if (/\/edit\/work-area$|\/create\/work-area$/.test(path)) return RBAC.ALBUM_PHOTOS_LIST
  if (/\/edit\/album-images$|\/create\/album-images$/.test(path)) return RBAC.ALBUM_PHOTOS_LIST
  if (/\/edit\/workflow$|\/create\/workflow$/.test(path)) return RBAC.ALBUM_MEMBERS_LIST
  if (/\/albums\/\d+\/edit\/(base-info|top-promotion|launch-poster|loading-image|basic-ad|side-ad|info-card|bottom-promotion-bar|batch-watermark|large-image-detail)/.test(path)) {
    return RBAC.ALBUM_DISPLAY_SETTINGS
  }
  if (path.startsWith('/dashboard/albums/create/') && path !== '/dashboard/albums/create') {
    const sub = path.replace('/dashboard/albums/create/', '')
    if (sub && sub !== 'workflow' && sub !== 'work-area' && sub !== 'album-images') {
      return RBAC.ALBUM_DISPLAY_SETTINGS
    }
  }

  if (path.startsWith('/dashboard/albums/create')) return RBAC.ALBUM_CREATE
  if (/\/albums\/\d+\/edit\/private/.test(path)) return RBAC.ALBUM_EDIT
  if (/\/albums\/\d+\/edit/.test(path)) return RBAC.ALBUM_EDIT

  return null
}
